module.exports = require('./dist/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/index.js
 ** module id = 1056
 ** module chunks = 1
 **/